export { default } from './CertificateForDownload';
